import { ga4Track, toggleInteraction } from '@unisporkal/ga4';
import useSelectedSubscriptionOption from './useSelectedSubscriptionOption';
import useSelectedUltraPack from './useSelectedUltraPack';

// Not a real pack — represents the "single image" option in the selector.
export const SINGLE_IMAGE_PACK_SIZE = 1;

type ToToggleSelection = (packSize: number) => string;

type UseSelectPricingOptions = {
  toToggleSelection?: ToToggleSelection;
};

const toAlcToggleSelection: ToToggleSelection = (packSize) =>
  `${packSize}_alc_toggle`;

const trackToggle = (toggleSelection: string) =>
  ga4Track(
    toggleInteraction({
      toggle_interaction: 'rf_toggle',
      toggle_selection: toggleSelection,
      ui_element_location: 'adp_buy_card',
    })
  );

const useSelectPricing = (options: UseSelectPricingOptions = {}) => {
  const toToggleSelection = options.toToggleSelection ?? toAlcToggleSelection;
  const { setSelectedSubscriptionOption } = useSelectedSubscriptionOption();
  const { setSelectedUltraPack } = useSelectedUltraPack();

  const selectPricing = (packSize: number) => {
    const isSingleImage = packSize === SINGLE_IMAGE_PACK_SIZE;
    setSelectedSubscriptionOption(isSingleImage ? 'single' : 'ultrapack');
    setSelectedUltraPack(isSingleImage ? null : packSize);

    trackToggle(toToggleSelection(packSize));
  };

  const selectSingleImagePricing = () => selectPricing(SINGLE_IMAGE_PACK_SIZE);

  const selectSubscriptionPricing = (sku: string | undefined) => {
    setSelectedSubscriptionOption('subscription');

    trackToggle(sku || '');
  };

  return {
    selectPricing,
    selectSingleImagePricing,
    selectSubscriptionPricing,
    trackToggle,
  };
};

export default useSelectPricing;
